export default __webpack_public_path__ + "static/media/Polexine_Logo_Portrait_01.20d59303.png";